/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/require-tagless-components */
import Component from '@ember/component';
import { service } from '@ember/service';
import Scopes from '@linc-technologies/linced-common/enums/scopes';
import { action } from '@ember/object';
import { classNames } from '@ember-decorators/component';

@classNames('tree-branch', 'layout-row', 'layout-align-start-start')
export default class TreeBranch extends Component {
  Scopes = Scopes;

  @service
  permissions;

  labelProperty = 'label';
  sortProperty = 'sequence';
  branchesProperty = 'subcategories';
  itemsProperty = 'items';
  addItemIcon = 'note-add';
  itemSingular = 'Item';

  // deleteBranch provides a way for a branch (i.e item with sub items like assessment categories) to be deleted from the tree.
  // Returns the single item as the first argument.
  deleteBranch = null;

  // deleteItem provides a way for a single item (i.e assessment) to be deleted from the tree.
  // Returns a single item as the first argument.
  deleteItem = null;

  open = false;

  @action
  toggle() {
    this.toggleProperty('open');
  }
}
